import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    dialogTitle: {
        "&.MuiDialogTitle-root": {
            color: theme.palette.text.primary,
            fontFamily: "Open Sans",
            fontSize: "28px",
            fontWeight: 600,
            paddingBottom: 0,
        },
    },
    dialogContent: {
        "&.MuiDialogContent-root": {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(4),
            paddingTop: theme.spacing(3),
        },
    },
    fieldRow: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
    },
    fieldLabel: {
        "&.MuiTypography-root": {
            color: theme.palette.primary.dark,
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: 700,
            textTransform: "uppercase",
        },
    },
    intervalSelect: {
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "4px",
        boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
        height: "56px",
        "& .MuiOutlinedInput-notchedOutline": {
            border: 0,
        },
        "& .MuiSelect-select": {
            color: theme.palette.text.primary,
            fontFamily: "Open Sans",
            fontSize: "22px",
            fontWeight: 400,
        },
    },
    scrapInput: {
        "& .MuiOutlinedInput-root": {
            backgroundColor: theme.palette.secondary.main,
            borderRadius: "4px",
            boxShadow: "0px 2px 0px rgba(62, 93, 138, 0.2)",
            height: "56px",
            paddingRight: theme.spacing(1),
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: 0,
        },
        "& input": {
            color: theme.palette.text.primary,
            fontFamily: "Open Sans",
            fontSize: "22px",
            fontWeight: 400,
            padding: "0 14px",
            textAlign: "left",
            // Hide the native number-input spin buttons — we provide custom
            // +/- icon buttons in the end adornment for tablet operators.
            "&[type=number]": {
                MozAppearance: "textfield",
            },
            "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
            },
        },
    },
    scrapAdornment: {
        "&.MuiInputAdornment-root": {
            gap: theme.spacing(8),
            marginLeft: 0,
        },
    },
    scrapAdjustButton: {
        "&.MuiIconButton-root": {
            backgroundColor: "rgba(62, 93, 138, 0.12)",
            borderRadius: "6px",
            color: theme.palette.text.primary,
            height: "44px",
            padding: 0,
            width: "44px",
            "& .MuiSvgIcon-root": {
                fontSize: "28px",
            },
            "&:hover": {
                backgroundColor: "rgba(62, 93, 138, 0.22)",
            },
            "&.Mui-disabled": {
                opacity: 0.35,
            },
        },
    },
    shiftTotalRow: {
        alignItems: "center",
        backgroundColor: theme.palette.table.main,
        borderRadius: "4px",
        display: "flex",
        justifyContent: "space-between",
        padding: theme.spacing(2.5),
    },
    shiftTotalLabel: {
        "&.MuiTypography-root": {
            color: theme.palette.primary.dark,
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: 700,
            textTransform: "uppercase",
        },
    },
    shiftTotalValue: {
        "&.MuiTypography-root": {
            color: theme.palette.text.primary,
            fontFamily: "Open Sans",
            fontSize: "22px",
            fontWeight: 700,
        },
    },
    queuedNotice: {
        "&.MuiTypography-root": {
            color: theme.palette.warning.main,
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontStyle: "italic",
        },
    },
    pendingSyncNotice: {
        "&.MuiAlert-root": {
            alignItems: "center",
            backgroundColor: "transparent",
            color: theme.palette.warning.main,
            fontFamily: "Open Sans",
            fontSize: "16px",
            padding: 0,
        },
        "& .MuiAlert-icon": {
            color: theme.palette.warning.main,
            marginRight: theme.spacing(1),
            padding: 0,
        },
        "& .MuiAlert-message": {
            padding: 0,
        },
    },
    dropdownItemWithPending: {
        "&.MuiMenuItem-root": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
    },
    dropdownItemLabel: {
        flex: 1,
        fontFamily: "Open Sans",
        fontSize: "20px",
    },
    dropdownItemPendingIcon: {
        color: theme.palette.warning.main,
        marginLeft: theme.spacing(2),
    },
    errorText: {
        "&.MuiTypography-root": {
            color: theme.palette.error.main,
            fontFamily: "Open Sans",
            fontSize: "16px",
        },
    },
    submitButton: {
        "&.MuiButton-root": {
            backgroundColor: theme.palette.info.main,
            color: "#FFFFFF",
            fontFamily: "Open Sans",
            fontSize: "22px",
            fontWeight: 600,
            minWidth: "160px",
            padding: "10px 28px",
            textTransform: "none",
            "&:hover": {
                backgroundColor: theme.palette.info.lighter,
            },
            "&.Mui-disabled": {
                color: "#FFFFFF",
                opacity: 0.5,
            },
        },
    },
    cancelButton: {
        "&.MuiButton-root": {
            color: theme.palette.text.primary,
            fontFamily: "Open Sans",
            fontSize: "22px",
            fontWeight: 600,
            padding: "10px 24px",
            textTransform: "none",
        },
    },
}));
